import 'javascripts/all_pages.js'
import { stickyScroll } from 'javascripts/general_scripts';

jQuery(() => {
  stickyScroll();
});

/* stylesheet */
import 'javascripts/all_pages_styles.js'
import 'stylesheets/shortlist/default_styles.less'